import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid ? "bg-background-50/95 border-b border-background-200/80" : "border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-site items-center justify-between px-4 md:px-8">
        <a href="#top" className="group flex items-center gap-2.5">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md font-heading text-base font-bold ${
              solid ? "bg-primary-500 text-background-50" : "bg-primary-500 text-background-50"
            }`}
          >
            17
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-[17px] font-bold tracking-tight ${
                solid ? "text-foreground-950" : "text-background-50"
              }`}
            >
              17黑料网
            </span>
            <span
              className={`mt-1 text-[10px] tracking-[0.28em] ${
                solid ? "text-secondary-600" : "text-background-100/80"
              }`}
            >
              深度解析
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`cursor-pointer rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                solid
                  ? "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                  : "text-background-100/90 hover:bg-background-50/10 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-radar-line text-base"></i>
            订阅更新
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border md:hidden ${
              solid ? "border-background-200 text-foreground-800" : "border-background-100/40 text-background-50"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/80 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="mt-2 cursor-pointer rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
            >
              订阅更新
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}